import React, { useEffect, useState } from "react"
import Block from "@bappweb/block"
import Panel from "@bappweb/panel"
import Element from "@bappweb/element"
import Page from "@smpu-web/globalmodules/page"
import "../assets/style.scss"

type PropsType = {
  configValue: string,
}

const Notes = ({ configValue }: PropsType) => {
  return (
    <Page padding={false} className="notes-section">
      <Panel hasFooter={false} noHeader className="notes-container">
        <Element type="h2">Açıklamalar</Element>
        <Block dangerouslySetInnerHTML={{ __html: configValue }} />
      </Panel>
    </Page>
  )
}

export default Notes
